import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import * as React from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { default as Layers } from '@material-ui/icons/LayersOutlined';
import { default as CheckIcon } from '@material-ui/icons/Check';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
export const StyledMenuItem = withStyles(theme => ({
    root: {
        lineHeight: '20px',
        minHeight: '36px',
        fontSize: '14px',
        paddingLeft: '8px',
        paddingRight: '24px',
        '& .MuiListItemIcon-root': {
            position: 'absolute',
            left: '4px',
            top: '8px',
            color: 'green',
        },
        '& .MuiListItemText-root': {
            color: theme.palette.common.black,
            marginBottom: 0,
            marginTop: 0,
            '& .MuiListItemText-primary': {
                color: 'black',
                marginLeft: '24px',
            },
        },
    },
}))(MenuItem);
export const StyledMenu = withStyles({})((props) => (React.createElement(Menu, Object.assign({ getContentAnchorEl: null, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } }, props))));
const BaseMapSelect = (props) => {
    const { className, selectedLayer, mapLayers, onLayerChange } = props;
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClickListItem = (event) => {
        setIsMenuOpen(true);
        setAnchorEl(event.currentTarget);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMenu, { anchorEl: anchorEl, open: isMenuOpen, onClose: () => { setIsMenuOpen(false); }, className: className, variant: 'menu' }, mapLayers.map((layer) => {
            const selected = layer === selectedLayer;
            return (React.createElement(StyledMenuItem, { key: layer.name, selected: selected, onClick: () => onLayerChange(layer) },
                selected && (React.createElement(ListItemIcon, null,
                    React.createElement(CheckIcon, { fontSize: "small" }))),
                React.createElement(ListItemText, { primary: layer.name })));
        })),
        React.createElement(IconButton, { color: 'inherit', onClick: handleClickListItem },
            React.createElement(Layers, null))));
};
export default BaseMapSelect;
